import { useStrings } from "@1js/localization-components";
import {
  DisplayCategoryKey,
  NoSearchResults,
  PromptTabs,
  SearchWentWrong,
  type CollectionFilterKeyType,
} from "@1js/pl-card-components";
import * as React from "react";
import { MetaOSAppContext } from "../../pages/metaos/MetaOSAppContext";
import { BrowseCollectionByTaskHeader } from "../../pages/metaos/v2/Home.web.strings";
import type { SearchResultsData } from "../../types";
import { PromptHeadingV2 } from "../AllPrompts/PromptHeadingV2";
import { NoWorkPlacePromptResults } from "../AllPrompts/WorkplacePrompts/NoWorkPlacePromptResults";
import BrowseByGridContainer from "../BrowseBy/BrowseByGridContainer.web";

type CollectionsContentSectionProps = {
  searchResultsData: SearchResultsData | undefined;
  onCollectionTileClick?: (
    filterKey: CollectionFilterKeyType,
    item: string
  ) => void;
  isMetaOsV2HomePage?: boolean;
  selectedTab?: PromptTabs;
  promptsLength?: number;
  titleOverride?: string;
};

export const CollectionsContentSection: React.FC<
  CollectionsContentSectionProps
> = ({
  searchResultsData,
  onCollectionTileClick,
  isMetaOsV2HomePage,
  selectedTab,
  promptsLength,
  titleOverride,
}) => {
  const metaOSAppContext = React.useContext(MetaOSAppContext);
  const localizations = useStrings({
    BrowseCollectionByTaskHeader,
  });

  const getNavItem = () => {
    if (selectedTab === PromptTabs.WorkplacePrompts) {
      return PromptTabs.WorkplacePrompts;
    } else if (selectedTab === PromptTabs.MicrosoftPrompts) {
      return PromptTabs.MicrosoftPrompts;
    } else if (selectedTab === PromptTabs.SavedPrompts) {
      return PromptTabs.SavedPrompts;
    } else if (selectedTab === PromptTabs.GroupPrompts) {
      return PromptTabs.GroupPrompts;
    } else if (selectedTab === PromptTabs.LikedPrompts) {
      return PromptTabs.LikedPrompts;
    } else if (selectedTab === PromptTabs.AgentPrompts) {
      return PromptTabs.AgentPrompts;
    }

    return searchResultsData && searchResultsData.queryText
      ? PromptTabs.SearchPrompts
      : PromptTabs.AllPrompts;
  };

  return (
    <>
      <PromptHeadingV2
        navItem={getNavItem()}
        searchResultsData={searchResultsData}
        isMetaOsV2HomePage={isMetaOsV2HomePage}
        titleOverride={titleOverride}
      />
      {selectedTab === PromptTabs.WorkplacePrompts && promptsLength == 0 && (
        <NoWorkPlacePromptResults />
      )}
      {searchResultsData &&
        searchResultsData.queryText &&
        searchResultsData.numOfResults === 0 &&
        !searchResultsData.searchError && (
          <>
            <NoSearchResults />
            <BrowseByGridContainer
              //eslint-disable-next-line @typescript-eslint/no-empty-function
              onBrowseByClick={onCollectionTileClick ?? (() => {})}
              type={DisplayCategoryKey}
              items={metaOSAppContext.categories}
              title={localizations.BrowseCollectionByTaskHeader()}
            />
          </>
        )}
      {searchResultsData &&
        searchResultsData.queryText &&
        searchResultsData.searchError && <SearchWentWrong />}
    </>
  );
};
